import React, { useState } from "react";
import { auth } from "../config/firebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";
import logo from "../components/sidebar/logo.svg";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (err) {
            setError("Invalid email or password. Please try again.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.loginBox}>
                <div style={styles.header}>
                    <img
                        src={logo}
                        alt="The Vivak"
                        style={styles.logo}
                    />
                    <h2 style={styles.title}>Admin Portal</h2>
                    <p style={styles.subtitle}>Please sign in to continue</p>
                </div>

                <form onSubmit={handleLogin} style={styles.form}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Email Address</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="admin@thevivak.com"
                            style={styles.input}
                            required
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            style={styles.input}
                            required
                        />
                    </div>

                    {error && <p style={styles.error}>{error}</p>}

                    <button
                        type="submit"
                        disabled={loading}
                        style={loading ? { ...styles.button, ...styles.buttonDisabled } : styles.button}
                    >
                        {loading ? "Signing in..." : "Sign In"}
                    </button>
                </form>

                <p style={styles.footer}>© 2026 The Vivak - Fine Hills Villa</p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F3F4F6",
        fontFamily: "'Inter', sans-serif",
    },
    loginBox: {
        width: "100%",
        maxHeight: "600px",
        maxWidth: "400px",
        padding: "40px",
        backgroundColor: "#FFFFFF",
        borderRadius: "16px",
        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
    },
    header: {
        marginBottom: "32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    logo: {
        width: "250px",
        height: "auto",
        marginBottom: "20px",
        backgroundColor: "#1F2937",
        padding: "20px",
        borderRadius: "12px",
    },
    title: {
        fontSize: "24px",
        fontWeight: "700",
        color: "#111827",
        margin: "0 0 8px 0",
    },
    subtitle: {
        fontSize: "14px",
        color: "#6B7280",
        margin: 0,
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        textAlign: "left",
    },
    inputGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },
    label: {
        fontSize: "14px",
        fontWeight: "500",
        color: "#374151",
    },
    input: {
        padding: "12px 16px",
        borderRadius: "8px",
        border: "1px solid #D1D5DB",
        fontSize: "14px",
        outline: "none",
        transition: "border-color 0.2s",
    },
    button: {
        marginTop: "12px",
        padding: "12px",
        backgroundColor: "#1F2937",
        color: "#FFFFFF",
        borderRadius: "8px",
        fontSize: "16px",
        fontWeight: "600",
        border: "none",
        cursor: "pointer",
        transition: "background-color 0.2s",
    },
    buttonDisabled: {
        backgroundColor: "#9CA3AF",
        cursor: "not-allowed",
    },
    error: {
        color: "#EF4444",
        fontSize: "13px",
        margin: 0,
        textAlign: "center",
    },
    footer: {
        marginTop: "32px",
        fontSize: "12px",
        color: "#9CA3AF",
    }
};

export default Login;
